import React from 'react'
import { Drawer, Form, Select, Button, notification, Alert } from 'antd'
import { getMarketingUserByUniversityFxn } from '../users/actions/user'
import { updateMarketingUserForAllAgentsFxn, updateMarketingUserForZeroCaseAgentsFxn } from './actions'
import { listAllCountries } from '../countries/actions/countries'
import { filterOption, InputBox, marketingUniversity } from '../../components/_utils/appUtils'
import _ from 'lodash'

const FormItem = Form.Item
const { Option } = Select

class UpdateAllMarketingUserZeroCaseDrawer extends React.Component {
  state = {
    selectedUser: null,
    allCountries: [],
    allUniversity: [],
    countryId: ''
  }
  events = {
    handleSubmit: async (e) => {
      const { dispatch, filters, showZeroCase } = this.props
      const { countryId, university, marketingUserId } = this.state
      if (!countryId) {
        notification.error({ message: 'Choose country' })
        return
      }
      if (!university) {
        notification.error({ message: 'Choose  university' })
        return
      }
      if (!marketingUserId) {
        notification.error({ message: 'Please choose marketing user' })
        return
      }
      delete filters.results
      delete filters.count

      let finalFilters = {
        filters: { ...filters, showZeroCase },
        data: {
          countryId, university, marketingUserId
        }
      }
      let resp = await dispatch(updateMarketingUserForZeroCaseAgentsFxn(finalFilters))
      if (resp && resp.success) {
        this.props.onClose()
      }
    },
    loadMarketingUser: async () => {
      let { countryId, university } = this.state
      if (university && countryId) {
        let obj = {
          countryId,
          university
        }
        let { data } = await getMarketingUserByUniversityFxn(obj)
        this.setState({ marketingUserList: data })
      }
    },
    loadCountry: async () => {
      let filters = {
        results: 100,
        count: 100,
        _id: { $in: this.props.marketingCounries }
      }

      let { data } = await this.props.dispatch(listAllCountries(filters))
      let obj = {
        allCountries: data
      }
      if (data && data.length) {
        obj.countryId = data[0]._id
      }
      this.setState({ ...obj }, () => {
        this.events.chooseCountry()
      })
    },
    chooseCountry: () => {
      let { countryId, allCountries } = this.state
      let findCountry = _.find(allCountries, (item) => item._id == countryId)
      let countryName = findCountry && findCountry.countryName ? findCountry.countryName.toLowerCase() : ''
      let uniData = marketingUniversity[`${countryName}List`] ? marketingUniversity[`${countryName}List`] : marketingUniversity.others
      let obj = { allUniversity: uniData }
      if (uniData && uniData.length) {
        obj.university = uniData[0].value
      }
      this.setState({ ...obj }, () => {
        this.events.loadMarketingUser()
      })
    }
  }

  componentDidMount() {
    this.events.loadCountry()
  }

  render() {
    const { visible, onClose, form } = this.props
    const { getFieldDecorator } = form
    let { university, allUniversity, countryId, allCountries } = this.state
    let { events } = this
    return (
      <Drawer
        visible={visible}
        width='35%'
        placement='right'
        onClose={onClose}
        title={'Update Marketing User In Agents (zero Case agents)'}>
        <div className={'unizportal'}>
          <div className={'card'}>
            <Form layout='vertical'>
              <InputBox title={'Choose Country'}>
                <Select
                  name='Country'
                  onChange={(x) => {
                    this.setState({ countryId: x }, () => {
                      events.chooseCountry()
                    })
                  }}
                  filterOption={filterOption}
                  allowClear
                  placeholder='Select Country'
                  value={countryId || undefined}>
                  {allCountries.map((item) => (
                    <Option value={item._id} key={item._id}>
                      {item.countryName}
                    </Option>
                  ))}
                </Select>
              </InputBox>
              <InputBox title={'Choose University'}>
                <Select
                  key={university}
                  name='University'
                  onChange={(x) => {
                    this.setState({ university: x }, () => {
                      events.loadMarketingUser()
                    })
                  }}
                  allowClear
                  placeholder='Select university'
                  value={university || undefined}>
                  {allUniversity.map((item) => (
                    <Option value={item.value} key={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </InputBox>
              <InputBox title={'Choose Marketing User'}>
                <Select
                  placeholder='Select a user'
                  onChange={(e) => {
                    this.setState({ marketingUserId: e })
                  }}>
                  {this.state.marketingUserList &&
                  this.state.marketingUserList.length > 0 &&
                  this.state.marketingUserList.map((user) => (
                    <Option key={user._id} value={user._id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </InputBox>
              {/* Submit Button */}
              <a className={'btn btn-primary roundNew mt10'} onClick={events.handleSubmit}>
                Update All Agents
              </a>
            </Form>

          </div>
        </div>
      </Drawer>
    )
  }
}

export default Form.create()(UpdateAllMarketingUserZeroCaseDrawer)
